import React from 'react';
import { useSelector } from 'react-redux';
import ListItem from 'components/ListItem';

import { SprayMethod } from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import { selectSprayMethodText } from './selectors';

export interface OwnProps {
    sprayMethod: SprayMethod;
}

type Props = OwnProps;

export default function SummaryApplicationSprayMethodListItem(
    props: Props
): React.ReactElement {
    const sprayMethod = useSelector((state: AppState) =>
        selectSprayMethodText(state, props)
    );

    return <ListItem description="Spray method" value={sprayMethod} />;
}
